define('home/views/ChannelCardView',[
    'home/views/common/ActivityCardView',
    'home/mixins/asChannelCard',
    'home/mixins/withChannelAvatar',
    'home/mixins/withReason',
], function (
    ActivityCardView,
    asChannelCard,
    withChannelAvatar,
    withReason
) {
    'use strict';

    /**
     * Base class for channel cards, cannot be used on it's own.
     */
    var ChannelCardView = ActivityCardView.extend({
        getChannel: function () {
            return this.channel || this.model.thread.forum.channel;
        },
    });

    asChannelCard.call(ChannelCardView.prototype);
    withReason.call(ChannelCardView.prototype);
    withChannelAvatar.call(
        ChannelCardView.prototype,
        ChannelCardView.prototype.getChannel
    );

    return ChannelCardView;
});


